import React, { useEffect, useState } from 'react'
import { SearchResultDeal } from '../models/shared/SearchResults'
import { renderSearchDealContent } from '../utils/presentation'
import { useOrganization } from '../context/OrganizationContext'
import { useText } from '../context/TextContext'
import { DEFAULT_CARD_LAYOUT } from '../models/shared/CardLayout'
import DealModal from './modals/DealModal'
import { Deal } from '../models/shared/Deal'
import { doc, onSnapshot } from 'firebase/firestore'
import { useFirestore } from 'reactfire'
import { COLLECTIONS } from '../utils/shared/constants'
import { fromFirebaseDoc } from '../utils/shared/firebase'
import { useUser } from '../context/UserContext'
import { UserRole } from '../models/shared/UserInvitation'

interface Props {
    hits: SearchResultDeal[]
}

export default function SearchDealsResults(props: Props) {
    const { user } = useUser();
    const { organization, orgId, orgRole } = useOrganization();
    const text = useText();
    const [selectedDealId, setSelectedDealId] = React.useState<string | null>(null);
    const [selectedDeal, setSelectedDeal] = useState<Deal | null>(null);
    const firebase = useFirestore();

    useEffect(() => {
        if (!selectedDealId) {
            setSelectedDeal(null);
            return;
        }

        return onSnapshot(doc(firebase, `${COLLECTIONS.ORGANIZATIONS}/${orgId}/${COLLECTIONS.DEALS}/${selectedDealId}`), snap => {
            const deal = fromFirebaseDoc<Deal>(snap);
            setSelectedDeal(deal);
        });

    }, [selectedDealId, setSelectedDeal, firebase, orgId])

    const layout = organization.cardLayout || DEFAULT_CARD_LAYOUT;
    let filteredHits = props.hits;
    if (orgRole === UserRole.WORKER) {
        filteredHits = props.hits.filter(deal => {
            const assignedTo = deal.assignedTo || [];
            return assignedTo.includes(user?.email || '');
        });
    }


    if (filteredHits.length === 0) {
        return <div>
            <h6>{text.deals}</h6>
            <div className='text-muted '>{text.noResults}</div>
        </div>
    }

    return (<div>

        <h6>{text.deals}</h6>
        <div className='d-flex flex-column gap-2 '>
            {filteredHits.map((result, index) => <div key={index} className='pointer' onClick={() => setSelectedDealId(result.objectID)}>
                <p className='m-0'>{renderSearchDealContent(layout.title, result, text)}</p>
                <p className='m-0 small text-muted'>{renderSearchDealContent(layout.subtitle, result, text)}</p>
            </div>)}
        </div>

        {selectedDeal && <DealModal deal={selectedDeal} onClose={() => setSelectedDealId(null)} />}
    </div>
    )
}
